import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KanbanComponent } from './kanban/kanban.component';
import { ProjetosComponent } from './projetos/projetos.component';
import { LoginComponent } from './login/login.component';
import { TemplateComponent } from './template/template.component';
import { CadastroComponent } from './cadastro/cadastro.component';
import { CadastroProjetoComponent } from './cadastro-projeto/cadastro-projeto.component';
import { RecuperacaosenhaComponent } from './recuperacaosenha/recuperacaosenha.component';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/confirm/:chave', component: LoginComponent },
  { path: 'alteracao-senha/:chave', component: RecuperacaosenhaComponent },
  { path: 'cadastro', component: CadastroComponent },
  { path: 'projetos', 
    component: ProjetosComponent,
    canActivate: [AuthGuard] 
  },
  { path: 'kanban/:id/:descricao', 
    component: KanbanComponent,
    canActivate: [AuthGuard] 
  },
  { path: 'cadastro-projeto', 
    component: CadastroProjetoComponent,
    canActivate: [AuthGuard] 
  },
  { path: 'cadastro-projeto/:id/:descricao', 
    component: CadastroProjetoComponent,
    canActivate: [AuthGuard] 
  },
  { path: 'template', 
    component: TemplateComponent,
    canActivate: [AuthGuard] //
  },
  { path: 'template/:id', 
    component: TemplateComponent,
    canActivate: [AuthGuard] //
  },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}